import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function Pricing() {
  const { t } = useTranslation();

  return (
    <section id="pricing" className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-4">
              {t('trafficPro.pricingTag')}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
              {t('trafficPro.pricingTitle')}{' '}
              <span className="text-primary-500">{t('trafficPro.pricingTitleHighlight')}</span>
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 gap-8 max-w-md mx-auto">
          <ScrollReveal delay={0}>
            <div className="bg-white border border-gray-200 rounded-2xl p-8 md:p-10 hover:shadow-[0_8px_40px_rgba(0,0,0,0.06)] transition-all duration-400 relative flex flex-col h-full">
              <p className="text-foreground-500 text-sm mb-6">{t('trafficPro.planADesc')}</p>

              <div className="mb-6">
                <div className="font-heading text-4xl font-bold text-foreground-950">
                  {t('trafficPro.planAPrice')}
                </div>
              </div>

              <ul className="space-y-3 mb-8 flex-1">
                {[1, 2, 3, 4, 5].map((n) => (
                  <li key={n} className="flex items-start gap-3">
                    <i className="ri-check-line text-primary-500 text-lg mt-0.5 flex-shrink-0"></i>
                    <span className="text-foreground-700 text-sm">{t(`trafficPro.planAItem${n}`)}</span>
                  </li>
                ))}
              </ul>

              <div className="flex items-start gap-2 mb-6 p-4 rounded-xl bg-[#F7F8FA]">
                <i className="ri-time-line text-foreground-400 text-lg mt-0.5 flex-shrink-0"></i>
                <span className="text-foreground-600 text-xs">{t('trafficPro.planATimeline')}</span>
              </div>

              <Link
                to="https://wa.link/em25v1"
                className="w-full py-3.5 rounded-xl bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-300 text-center block whitespace-nowrap"
              >
                {t('trafficPro.planACta')}
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}